import { Feature } from 'src/app/model/feature/feature.model';

export const FEATURES: Feature[] = [
  {
    title: $localize`:@@featureData.microServices.title:Vision`,
    description: $localize`:@@featuresData.microServices.description:To become a globally recognised leader in industrial solutions, distinguished by our unwavering dedication to innovation, quality, and trust. We strive to establish new standards in customer satisfaction, integrity, and excellence by continuously evolving, leveraging our experience of over three decades`,
    icon: '',
  },
  {
    title: $localize`:@@featureData.compactStorage.title:Mission`,
    description: $localize`:@@featuresData.compactStorage.description:Our mission at SR Group is to deliver exceptional industrial solutions that are characterised by innovation, integrity, and professionalism. We are dedicated to providing our clients with high-quality products and services that improve efficiency, safety, and sustainability, leveraging our experience of over three decades`,
    icon: '',
  },
  // {
  //   title: $localize`:@@featuresData.reliableDesign.title:Reliable Design`,
  //   description: $localize`:@@featuresData.reliableDesign.description:Shout out your business to the world using our responsive and user friendly user interface components. Customise them with your own needs to have unique and great user experiences to your clients.`,
  //   icon: 'fas fa-desktop',
  // },
];
